import {CurrencyFormat} from 'ultra/helpers/utils';

export default function CurrencyFormated(props) {
    // currency: https://en.wikipedia.org/wiki/ISO_4217#List_of_ISO_4217_currency_codes
    // code: https://gist.github.com/ncreated/9934896
    const {value, currency, minimumFractionDigits} = props;

    return <>{CurrencyFormat(value, currency, minimumFractionDigits)}</>
};
